mutation UpdatePosts($ids: [ID!]!, $input: UpdatePostsInput!) {
  updatePosts(ids: $ids, input: $input) {
    id
    title
    description
    text
    slug
    organization {
      id
      title
    }
    image {
      id
      url(format: HIGH)
    }
    tags {
      id
      title
    }
    publishAt
    accessOnlyViaLink
    createdAt
    updatedAt
  }
}
